export type WisemanId = 'sasha' | 'pickle_rick' | 'gonzo';

export interface WisemanPersona {
  id: WisemanId;
  name: string;
  epithet: string;
  focus: string;
  accent: string;
}

/** The Three Wisemen — separate agents with distinct voices and routing. */
export const WISEMEN: WisemanPersona[] = [
  {
    id: 'sasha',
    name: 'Sasha',
    epithet: 'Chemist frozen at peak clearance',
    focus:
      'Chemistry, cacti, plant science, consciousness, MDMA — deep mechanism dives (9–10).',
    accent: 'var(--neon-lime)',
  },
  {
    id: 'pickle_rick',
    name: 'Pickle Rick',
    epithet: 'Engineer in a hurry',
    focus:
      'Brain, cosmos, quantum, gadgets — gets ideas from 2 to 8 before someone shoots at him.',
    accent: 'var(--neon-cyan)',
  },
  {
    id: 'gonzo',
    name: 'Dr. Gonzo',
    epithet: 'Legal cannon, brief answers',
    focus:
      'Law, rights, trouble, history, retreats & marketplace — short and to the point (0–1).',
    accent: 'var(--neon-magenta)',
  },
];

const ROUTING_KEYWORDS: Record<WisemanId, string[]> = {
  sasha: [
    'chemistry',
    'extract',
    'extraction',
    'mdma',
    'mescaline',
    'psilocybin',
    'cactus',
    'cacti',
    'plant',
    'tree',
    'harvest',
    'prepare',
    'pharmacology',
    'consciousness',
    'psychoactive',
    'compound',
    'molecule',
  ],
  pickle_rick: [
    'brain',
    'neuro',
    'mental',
    'quantum',
    'gravity',
    'star',
    'space',
    'universe',
    'physics',
    'engineering',
    'technology',
  ],
  gonzo: [
    'legal',
    'law',
    'state',
    'states',
    'mushroom',
    'mushrooms',
    'allow',
    'arrest',
    'police',
    'rights',
    'trouble',
    'court',
    'lawyer',
    'policy',
    'retreat',
    'marketplace',
  ],
};

/** Suggest which Wiseman should answer (user can override in the UI). */
export function suggestWiseman(message: string): WisemanPersona {
  const normalized = message.trim().toLowerCase();
  let best: WisemanId = 'sasha';
  let bestScore = 0;
  (Object.keys(ROUTING_KEYWORDS) as WisemanId[]).forEach((id) => {
    const score = ROUTING_KEYWORDS[id].reduce(
      (acc, word) => (normalized.includes(word) ? acc + 1 : acc),
      0
    );
    if (score > bestScore) {
      bestScore = score;
      best = id;
    }
  });
  return WISEMEN.find((w) => w.id === best) ?? WISEMEN[0];
}

export function wisemanById(id: WisemanId): WisemanPersona | undefined {
  return WISEMEN.find((w) => w.id === id);
}
